(function() {
  'use strict';
  angular
    .module('cfn')
    .run(run)
    .service('cfn-RouteRedirectService', RouteRedirectService);

  run.$inject = ['$rootScope', 'cfn-RouteRedirectService'];

  function run($rootScope, RouteRedirectService) {
    $rootScope.allowNavigation = RouteRedirectService.allowNavigation;
    $rootScope.preventNavigation = RouteRedirectService.preventNavigation;

    $rootScope.$on(
      '$locationChangeStart',
      RouteRedirectService.locationChangeStart
    );
    $rootScope.$on('$routeChangeStart', RouteRedirectService.routeChangeStart);

    window.onbeforeunload = RouteRedirectService.onbeforeunload;
  }

  RouteRedirectService.$inject = [
    '$location',
    'CfnUpgradeRightsDialogService',
    '$rootScope',
    '$window'
  ];
  function RouteRedirectService(
    $location,
    CfnUpgradeRightsDialogService,
    $rootScope,
    $window
  ) {
    var event, newUrl, oldUrl, preventNavigationUrl;

    return {
      routeChangeStart: routeChangeStart,
      locationChangeStart: locationChangeStart,
      allowNavigation: allowNavigation,
      preventNavigation: preventNavigation,
      rejectRouteIfNoRights: rejectRouteIfNoRights,
      onbeforeunload: onbeforeunload
    };

    function routeChangeStart(_event_, _newUrl_, _oldUrl_) {
      event = _event_;
      newUrl = _newUrl_;
      oldUrl = _oldUrl_;

      redirectIfNotLoggedIn();

      $rootScope.unsavedChanges = false;
    }

    function locationChangeStart(_event_, _newUrl_, _oldUrl_) {
      event = _event_;
      newUrl = _newUrl_;
      oldUrl = _oldUrl_;

      rejectRouteIfNoRights();
      rejectRouteIfNoSavedChanges(); // TODO: this code is useless as unsavedChanges is reset when routeChangeStart event is fired, just before locationChangeStart event
    }

    function redirectIfNotLoggedIn() {
      var url = '';

      if (newUrl && newUrl.originalPath) {
        url = newUrl.originalPath;
      }

      if ($rootScope.credentials.loggedIn) {
        // Don't let a logged in user access routes that are not meant for him
        if (app.isPublicRoute() && !app.isHybridRoute()) {
          $location.path('/dashboard');
          return;
        }

        // CFNPOC-10166 In addition to routes, there are also separate html files that are not meant for logged in users
        var actualLocation = document.location.pathname;
        if (app.isLoginPage()) { // TODO app.isRegistrationPage()?
          window.location.href = 'index.html#/dashboard';
        }
      } else {
        /* allowed paths */
        if (url.indexOf('/dashboard/') != -1) {
          $location.path('/');
        }
      }
    }

    function rejectRouteIfNoRights() {
      var hasRights = app.hasRightToCurrentRoute();

      if (!hasRights) {
        CfnUpgradeRightsDialogService.onlyShowDialog();
        if (newUrl === oldUrl) {
          // Direct entry into the locked page tried
          $location.path('/dashboard');
        } else {
          event.preventDefault();
          $window.location = oldUrl; //when route right is lazy loaded from module
        }
        return hasRights;
      }

      // Allow navigation if our old url wasn't where we prevented navigation from
      if (preventNavigationUrl !== oldUrl || preventNavigationUrl === null) {
        $rootScope.allowNavigation();
      }

      return hasRights;
    }

    function rejectRouteIfNoSavedChanges() {
      if (
        $rootScope.unsavedChanges &&
        !window.confirm(
          i18n(
            'fe.message.confirm.unsavedModifications',
            'Ungespeicherte Änderungen gehen verloren. Sind Sie sicher?'
          )
        )
      ) {
        event.preventDefault();
      } else {
        $rootScope.allowNavigation();
      }
    }

    function allowNavigation() {
      $rootScope.unsavedChanges = false;
    }

    function preventNavigation() {
      $rootScope.unsavedChanges = true;
      preventNavigationUrl = $location.absUrl();
    }

    function onbeforeunload() {
      // Use the same data that we've set in our angular app
      if (
        $rootScope.preventNavigation &&
        $location.absUrl() === preventNavigationUrl
      ) {
        return i18n(
          'fe.message.confirm.unsavedModifications',
          'Ungespeicherte Änderungen gehen verloren. Sind Sie sicher?'
        );
      }
    }
  }
})();
